<script lang="ts">
import Vue from 'vue'
import Card from "@/components/ui/Card";
import Checkbox from "@/components/ui/Checkbox";
import TariffSetting from "@/views/insuranceProducts/components/TariffSetting.vue";
import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin"

export default Vue.extend({
    name: "TariffGreenCardItem",
    components: {TariffSetting, Checkbox, Card},
    props: {
        tariff: {
            type: Object,
        },
        companyName: {
            default() {
                return ''
            }
        }
    },
    mixins: [tariffMixin],
})
</script>

<template>
    <div>
        <Card>
            <div class="tariff-item d-flex justify-content-between flex-row align-items-center">
                <div class="column">
                    <div class="head">Тип продукту</div>
                    <div class="d-flex">
                        <div class="mr-2" v-if="$route.params.id">
                            <Checkbox v-model="tariff.isActive" @change="updateTariff(tariff)"></Checkbox>
                        </div>
                        <div>
                            Зелена карта
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="head">Тип користувача</div>
                    <div>{{ $store.getters.CUSTOMER_TYPES.filter(t => tariff.parameters.userTypes.includes(t.id)).map(t => t.value).join(', ') }}</div>
                </div>
                <!--            <div class="column">-->
                <!--                <div class="head">ОТК</div>-->
                <!--                <div>test</div>-->
                <!--            </div>-->
                <div class="column">
                    <div class="head">Комісія/Знижка, %</div>
                    <div v-if="$route.params.id">
                        <TariffSetting v-model="tariff">
                            Налаштування тарифів {{ companyName }} для точки продажу id: {{ tariff.userId }}
                        </TariffSetting>
                    </div>
                    <div v-else-if="isMainPartner">{{ tariff.commission - tariff.gap }}</div>
                    <div v-else>{{ tariff.commission }}</div>
                </div>
                <div class="column">
                    <div class="head">Зона  реєстрації ТЗ</div>
                    <div>{{ tariff.parameters.osagoZones.join(', ') }}</div>
                </div>
                <div class="column">
                    <div class="head">Тип ТЗ</div>
                    <div>{{ tariff.parameters.autoCategoryTypes.join(', ') }}</div>
                </div>
                <div class="column">
                    <div class="head">Програма</div>
                    <div>{{ tariff.parameters.programms ? tariff.parameters.programms.join(', ') : 1 }}</div>
                </div>
            </div>
        </Card>
    </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/app/components/_tariff-item";

</style>
